export const BANNER_CONTENT_ACTIVITY_PAGE = {
  SUB_TITLE: 'Openings with Premium Services are over 3x more likely to result in a hire.',
  TITLE: 'Want to fill your opening faster? Add a Premium Service.',
};

export const BANNER_CONTENT_CREATE_OPENING_PAGE = {
  SUB_TITLE: 'Openings with Premium Services are over 3x more likely to result in a hire.',
  TITLE: 'Want to fill your opening faster? <br/> Add a Premium Service.',
};

export const BANNER_CONTENT_DASHBOARD = {
  SUB_TITLE: 'Openings with Premium Services are <br/> over 3x more likely to result in a hire.',
  TITLE: 'Want to fill your opening faster? <br/> Add a Premium Service.',
};
